import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-minhas-compras',
  templateUrl: './minhas-compras.component.html',
  styleUrls: ['./minhas-compras.component.css']
})
export class MinhasComprasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
